import { ColumnChartComponent } from 'components/charts/ColumnChartComponent';
import React, { useEffect } from 'react';
import { AreaChartComponent } from '../../../SingleSurveyDashboardContainer/AreaChartComponent';
import { CardComponent } from '../../CardComponent';
import { useAppDispatch, useAppSelector } from '../../hooks';
import {
  selectFirstLoadFulfilled,
  selectIsTrendDataLoading,
  selectTrendAPIResponse,
  selectTrendChartCategories,
  selectTrendChartData,
  selectTrendComponentState,
  selectTrendHasError,
  selectTrendLabel,
  setChartData,
  setHTMLSubtitle,
} from './trendComponentSlice';

export function TrendComponent() {
  const componentState = useAppSelector(selectTrendComponentState);
  const apiResponse = useAppSelector(selectTrendAPIResponse);
  const isTrendLoading = useAppSelector(selectIsTrendDataLoading);
  const trendHasError = useAppSelector(selectTrendHasError);
  const trendLabel = useAppSelector(selectTrendLabel);
  const trendHasData = useAppSelector(selectFirstLoadFulfilled);
  const chartData = useAppSelector(selectTrendChartData);
  const chartCategories = useAppSelector(selectTrendChartCategories);
  const chartHTMLSubtitle = componentState.chartHTMLSubtitle;
  const customer = componentState.apiResponse.label;
  const avannisAverage = componentState.apiResponse.avannis;

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHTMLSubtitle());
    dispatch(setChartData());
  }, [apiResponse]);

  return (
    <CardComponent title={`${trendLabel} Trend`} isLoading={isTrendLoading} hasError={trendHasError}>
      {(!isTrendLoading || trendHasData) &&
        renderChart(
          chartData,
          chartCategories,
          chartHTMLSubtitle,
          customer,
          avannisAverage,
          apiResponse.factor
        )}
    </CardComponent>
  );
}

const renderChart = (
  chartData,
  chartCategories,
  chartHTMLSubtitle,
  customer,
  avannisAvg: any,
  factor: number
) => {
  if (chartData.length < 2) {
    return (
      <ColumnChartComponent
        categories={chartCategories}
        dataPoints={chartData}
        htmlSubtitle={chartHTMLSubtitle}
        name={''}
        title={chartHTMLSubtitle}
        noDataMessage={'There is no data for the selected criteria'}
        avannisAverage={avannisAvg}
        factor={factor}
      />
    );
  } else {
    return (
      <AreaChartComponent
        title={`${customer} Trend`}
        isLoading={false}
        legend={false}
        categories={chartCategories}
        factor={factor.toString()}
        seriesName={''}
        series={[]}
        avannisAvg={avannisAvg}
        dataPoints={chartData}
        htmlSubtitle={chartHTMLSubtitle}
      />
    );
  }
};
